import {colors, Divider, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import {Communication} from '../../../graphql/comms.datatypes';
import {WcvLogCodes} from '../../../graphql/logs.datatypes';
import CommunicationEdit from './CommunicationEdit';
import getCommunication from './getCommunication.api';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
}));

const getBlankCommunication = (): Communication => {
  return {
    id: -1,
    ident: '',
    communication_type: 0,
    title: '',
    body: '',
    active: true,
    receiver: 0,
    log_code: WcvLogCodes.ADD_NOTE,
    mandatory: false,
    triggerValues: [],
  };
};

const CommsDetails = () => {
  const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
  const classes = useStyles();
  const {id} = match.params;
  const newComms = id === 'new';
  const title = 'Edit Communication';

  const communicationData = newComms ? {
    loading: false,
    data: {communication: getBlankCommunication()},
    error: null
  } : getCommunication(id);
  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    if (communicationData.error) {
      enqueueSnackbar(`There was an error loading Communication ${id}`, {variant: 'error'});
      history.push('/comms');
    }
  }, [communicationData.error]);

  return (
    <Page className={classes.root} title={title}>
      <PageHeader section="Communication" title={title}/>
      <Divider className={classes.divider}/>
      <LoadingOverlay loading={communicationData.loading}>
        {!communicationData.loading && communicationData.data && communicationData.data.communication && (
          <CommunicationEdit communication={communicationData.data.communication}/>
        )}
      </LoadingOverlay>
    </Page>
  );
};

export default CommsDetails;
